import React from 'react';

const AgentOrangeExposureDescription = (
  <ul>
    <li>
      <strong>Republic of Vietnam</strong> between January 9, 1962, and May 7,
      1975
    </li>
    <li>
      <strong>Thailand at any US or Royal Thai base</strong> between January 9,
      1962, and June 30, 1976
    </li>
    <li>
      <strong>Laos</strong> between December 1, 1965, and September 30, 1969
    </li>
    <li>
      <strong>Cambodia at Mimot or Krek, Kampong Cham Province</strong> between
      April 16, 1969, and April 30, 1969
    </li>
    <li>
      <strong>Guam or American Samoa (or their territorial waters)</strong>{' '}
      between January 9, 1962, and July 31, 1980
    </li>
    <li>
      <strong>Johnston Atoll (or a ship that called there)</strong> between
      January 1, 1972, and September 30, 1977
    </li>
  </ul>
);

export default AgentOrangeExposureDescription;
